import { NOTIFICATIONS_MODULE } from '../modules/notifications'
import { FORMS_MODULE } from '../modules/forms'
import { FILES_MODULE } from '../modules/files'
import { ROLES_MODULE, USERS_MODULE } from '../modules/users'
import { STATISTICS_MODULE, WEARABLE_MODULE, INTENSITY_MODULE } from '../modules/statistics'
import { PATOLOGY_MODULE } from '../modules/patologies'
import { PROTOCOL_MODULE } from '../modules/protocols'

const apiURL = process.env.REACT_APP_BACKEND_URL
// const apiURL = 'http://localhost:8000'

export const moduleURLs = {
  [NOTIFICATIONS_MODULE]: `${apiURL}/notifications`,
  [FORMS_MODULE]: `${apiURL}/forms`,
  [FILES_MODULE]: `${apiURL}/files`,
  [USERS_MODULE]: `${apiURL}/users`,
  [ROLES_MODULE]: `${apiURL}/users/roles`,
  [STATISTICS_MODULE]: `${apiURL}/wearable`,
  [WEARABLE_MODULE]: `${apiURL}/userWearable`,
  [INTENSITY_MODULE]: `${apiURL}/userIntensity`,
  [PATOLOGY_MODULE]: `${apiURL}/patologies`,
  [PROTOCOL_MODULE]: `${apiURL}/protocols`,
}
